class JuridicalInnValidator {
	regexp = /^([0-9]{10})$/;
	message = '';

	validate = (value: string): boolean => {
		let result = this.regexp.test(value);
		this.message = 'Поле должно содержать 10 цифр';
		if (!result) {
			return result;
		}

		let n10 =
			2 * parseInt(value[0]) +
			4 * parseInt(value[1]) +
			10 * parseInt(value[2]) +
			3 * parseInt(value[3]) +
			5 * parseInt(value[4]) +
			9 * parseInt(value[5]) +
			4 * parseInt(value[6]) +
			6 * parseInt(value[7]) +
			8 * parseInt(value[8]);

		n10 = (n10 % 11) % 10;

		result = n10 === parseInt(value[9]);
		this.message = 'Некорректный ИНН юридического лица';
		return result;
	};
}

export default JuridicalInnValidator;
